import {Injectable, Injector} from "@angular/core";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {AccountPaymentData} from "./account-payment.data";

@Injectable()
export class AccountPaymentEntityModel extends EntityModel<AccountPaymentData> {

    constructor(injector: Injector) {
        super(injector, AccountPaymentData);
    }

    override isEntityCloneable(): boolean {
        return false;
    }
}
